import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()({
    menuItem: {
        lineHeight: "14px", 
        fontSize: "14px",
        fontFamily: "MD Primer", 
        alignItems: "start",        
        "& a": {
            color: "var(--color-neutral-800)",
            fontSize: "14px",
            fontFamily: "MD Primer", 
            fontWeight: "bold", 
            "&::before": {
                backgroundColor: "inherit"
            }, 
            "&:hover": {
                "&::before": {
                    backgroundColor: "inherit"
                }
            }

        }
      },

});
